import AboutHero from './components/AboutHero';
import SharedTrustBar from '../../components/feature/SharedTrustBar';
import BrandSection from './components/BrandSection';
import MidCTA from '../../components/feature/MidCTA';
import SharedAIBlock from '../../components/feature/SharedAIBlock';
import SharedHowItWorks from '../../components/feature/SharedHowItWorks';
import SharedWhyChooseUs from '../../components/feature/SharedWhyChooseUs';
import AboutGlobal from './components/AboutGlobal';
import SharedTestimonials from '../../components/feature/SharedTestimonials';
import SharedFAQ from '../../components/feature/SharedFAQ';
import SharedFinalCTA from '../../components/feature/SharedFinalCTA';
import { aboutAIItems, repairSteps, whyReasons } from '../../mocks/shared-sections';
import { aboutFaqs } from '../../mocks/faqs';

export default function AboutPage() {
  return (
    <main className="min-h-screen">
      {/* 1. Hero */}
      <AboutHero />
      {/* 2. Trust Bar */}
      <SharedTrustBar />
      {/* 3. Brand / Company Section */}
      <BrandSection />
      {/* Mid CTA */}
      <MidCTA
        headline="See What We've Built for Surfers"
        sub="Explore the full PHIX Doctor product range — kits for every board and every repair."
        btnLabel="Browse Products"
        btnTo="/products"
        urgency="4.9★ rated by 3,000+ verified buyers"
        variant="teal"
      />
      {/* 4. AI Answer Block */}
      <SharedAIBlock
        title="Who is PHIX Doctor?"
        subtitle="Straight answers about who we are, what we do, and why surfers worldwide trust us."
        items={aboutAIItems}
        bgClass="bg-[#F5EFE6]"
      />
      {/* 5. How It Works — our product process */}
      <SharedHowItWorks
        title="How Our Products Work"
        subtitle="The same 5-step sun-powered repair process — engineered in our lab, tested by pros worldwide."
        steps={repairSteps}
        bgClass="bg-white"
      />
      {/* 6. Why Choose Us — brand pillars */}
      <SharedWhyChooseUs
        reasons={whyReasons}
        showComparison={true}
        bgClass="bg-[#F5EFE6]"
      />
      {/* Mid CTA after Why Choose Us */}
      <MidCTA
        headline="Ready to Experience the PHIX Difference?"
        sub="World-class repair tech, now available at 1,200+ stores worldwide and online."
        btnLabel="Shop PHIX Doctor"
        btnTo="/products"
        urgency="Free Micro Kit on orders over $40"
        variant="orange"
      />
      {/* 7. Global Reach Section */}
      <AboutGlobal />
      {/* 8. Testimonials */}
      <SharedTestimonials />
      {/* 9. FAQ */}
      <SharedFAQ
        faqs={aboutFaqs}
        title="About Our Brand"
        subtitle="Common questions about who PHIX Doctor is and what we stand for."
        bgClass="bg-[#F5EFE6]"
      />
      {/* 10. Final CTA */}
      <SharedFinalCTA
        headline="Join Thousands of Surfers"
        headlineAccent="Using PHIX Doctor."
        primaryLabel="Shop All Kits"
        secondaryLabel="Find a Store"
        secondaryTo="/where-to-buy"
        urgency="Trusted by 40,000+ surfers in 60+ countries."
        offer="Free Micro Kit with orders over $40"
      />
    </main>
  );
}
